import ReactSlider from 'react-slider';
import styled from 'styled-components';

const StyledSlider = styled(ReactSlider)`
    width: 100%;
    height: 25px;
`;

const StyledThumb = styled.div`
    height: 25px;
    line-height: 25px;
    width: 25px;
    text-align: center;
    background-color: var(--sp-dark-blue);
    color: #fff;
    border-radius: 50%;
    cursor: grab;
`;

const removeKeyFromProps = (props) => (
  Object.keys(props).reduce((filteredProps, key) =>
    key === "key" ? filteredProps : {...filteredProps, [key]: props[key]},
  {})
);

const Thumb = (props, state) => (
  <StyledThumb {...removeKeyFromProps(props)} key={props.key}>{state.valueNow}</StyledThumb>
);

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background: ${props => (props.index === 1 ? '#696969' : '#ddd')};
    border-radius: 999px;
    height: 5px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
`;

const Track = (props, state) => (
  <StyledTrack {...removeKeyFromProps(props)} key={props.key} index={state.index} />
);

const Slider = ({onChange}) => 
  <StyledSlider
    defaultValue={[1, 48]}
    min={1}
    max={48}
    renderTrack={Track}
    renderThumb={Thumb}
    onChange={onChange}
  />;

export default Slider;